import { render, staticRenderFns } from "./DiscountsWrapper.vue?vue&type=template&id=62a74d01&scoped=true&"
import script from "./DiscountsWrapper.vue?vue&type=script&lang=js&"
export * from "./DiscountsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a74d01",
  null
  
)

export default component.exports